module.exports = __webpack_public_path__ + "media/customizations/regencyatnorthskye/logo-be4b1207d534b0d06c7053f45310c6ee.png";